import axios from './base';

export const getSurveyList = (params) => {
  return axios.post('/survey/getList', {
    pageSize: 10,
    ...params,
  });
};

// 获取已发布问卷无分页
export const getSurveyListAll = () => {
  return axios.post('/survey/getList/notPaging',{});
};

export const getSurveyById = (id) => {
  return axios.get('/survey/getSurvey', {
    params: {
      surveyId: id,
    },
  });
};

export const saveSurvey = ({ surveyId, configData }) => {
  return axios.post('/survey/updateConf', { surveyId, configData });
};

export const getlastPublishVersion = ({ pageId }) => {
  return axios.get('/survey/getLastPublishVersion', { params: { pageId } });
};

export const publishSurvey = ({ surveyId, version }) => {
  return axios.post('/survey/publishSurvey', {
    surveyId,
    version,
  });
};

export const createSurvey = (data) => {
  return axios.post('/survey/createSurvey', data);
};

export const getSurveyHistory = ({ surveyId, historyType }) => {
  return axios.get('/surveyHistory/getList', {
    params: {
      surveyId,
      historyType,
    },
  });
};

export const deleteSurvey = (surveyId) => {
  return axios.post('/survey/deleteSurvey', {
    surveyId,
  });
};

export const updateSurvey = (data) => {
  return axios.post('/survey/updateMeta', data);
};

// 获取自己已发布的问卷
export const getOwner = (data) => {
  return axios.post('/survey/owner', data);
};
